import cn from 'classnames';

import styles from './AlphaButtons.module.scss';

export type AlphaOption = {
  name: string;
  label: string;
  disabled: boolean;
  active: boolean;
};
export type AlphaButtonsProps = {
  options: Array<AlphaOption>;
  onClick: (option: AlphaOption) => void;
  className?: string;
};

const AlphaButtons = (props: AlphaButtonsProps): JSX.Element => {
  const { options, onClick, className } = props;

  return (
    <ul className={cn(styles.main, className)}>
      {options.map((option) => (
        <li key={option.name} className={styles['letters-list-item']}>
          {option.disabled === false ? (
            <button
              className={cn(styles['letters-list-button'], 'heading-h4', {
                [styles['letters-list-button-active']]: option.active,
              })}
              onClick={() => onClick(option)}
              type="button"
            >
              {option.label}
            </button>
          ) : (
            <span className={cn(styles['letters-list-button-disabled'], 'heading-h4')}>
              {option.label}
            </span>
          )}
        </li>
      ))}
    </ul>
  );
};

export default AlphaButtons;
